import { allTimezones } from 'react-timezone-select';

const COMMON_CONSTANTS = {
  APP_VERSION: '1.6',
  CACHE_POLICIES: {
    NO_CACHE: 'no-cache',
    NETWORK_ONLY: 'network-only',
    CACHE_AND_NETWORK: 'cache-and-network',
    CACHE_FIRST: 'cache-first'
  },
  IS_INSIDE_INPUT_VARIABLES: {
    getTechnicianList: true,
    getClientUserAssociationsList: true
  },
  COMPANY: 'COMPANY',
  MSP: 'MSP',
  IT: 'IT',
  TECHNICIAN: 'TECHNICIAN',
  REQUESTER: 'REQUESTER',
  TIMEZONES: {
    ...allTimezones,
    'America/New_York': 'New York'
  }
};

const FEATURE_GATING_STATUS = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED',
  EXPIRED: 'EXPIRED',
  IN_TRIAL: 'IN_TRIAL',
  TRIAL_ELIGIBLE: 'TRIAL_ELIGIBLE'
};

const STORE = {
  CACHE_STRATEGY: {
    MEMORY: 'memory',
    PERSISTENT: 'persistent',
    SESSION: 'session'
  },
  CACHE_TAB_BEHAVIOR: {
    PERSIST: 'persist',
    RESET: 'reset'
  },
  SCOPE: {
    GLOBAL: 'global',
    TAB: 'tab'
  },
  TYPE: {
    UI: 'ui',
    FORM: 'form'
  }
};

export { COMMON_CONSTANTS, FEATURE_GATING_STATUS, STORE };
